import { Component, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { CstFormBuilder, CstFormGroup } from "src/app/_uncategorised_models_services/cst-form-group";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";

export interface IInfoportalFoldersFilter {
  searchText: string;
  tagIDs: number[];
  dateRangeBegin: Date;
  dateRangeEnd: Date;
}

@Component({
    templateUrl: "./folders-filter-popup.component.html",
    styleUrls: ["./folders-filter-popup.component.scss"],
    standalone: false
})
export class InfoportalApiFolderFilterPopupComponent extends CstResponsivePopupComponentBase<IInfoportalFoldersFilter> {
  public form: CstFormGroup<IInfoportalFoldersFilter> = null;
  public loading = false;

  public constructor() {
    const fb = inject(CstFormBuilder);

    super();
    this.form = fb.group<IInfoportalFoldersFilter>({
      searchText: new FormControl(""),
      tagIDs: new FormControl([]),
      dateRangeBegin: new FormControl(null),
      dateRangeEnd: new FormControl(null),
    });
  }

  public onInitialised() {
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }

  public onAccept() {
    if (!this.form.valid) {
      return;
    }
    this.close(this.form.value as IInfoportalFoldersFilter);
  }

  public onCancel() {
    this.close(null);
  }
}
